module.exports = __webpack_public_path__ + "static/devops-benefits-00972128871cb8438a8bc685b9c2512c.webm";